import { mutator } from 'satcheljs';
import { clearDateFilterAction, clearExtensionFilterAction } from 'owa-files-filter-contextmenu';
import { assertNever } from 'owa-assert';
import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';
import { FilterType } from '../Schema/FilterState';
import { getFilterStore } from '../store/FilterStore';
import { updateItemsViewCache } from '../store/cache';

// exported for typings
export function clearFilter(type: FilterType);
export function clearFilter(type: FilterType.ExtensionGroup, extension: FileExtensionType);
export function clearFilter(type: FilterType, extension?: FileExtensionType) {
    const filterState = getFilterStore();
    switch (type) {
        case FilterType.ExtensionGroup:
            if (extension !== null && extension !== undefined) {
                filterState.extensionGroupFilter.selectedValue.delete(extension.toString());
            } else {
                filterState.extensionGroupFilter.selectedValue.clear();
            }
            break;
        case FilterType.PhotosOnly:
            filterState.photosOnlyFilter.selectedValue = false;
            break;
        case FilterType.Folder:
            filterState.folderFilter.selectedValue = null;
            break;
        case FilterType.Size:
            filterState.sizeFilter.selectedValue = null;
            break;
        case FilterType.Search:
            filterState.searchFilter.selectedValue = null;
            break;
        case FilterType.BroadExtensionGroupFilter:
        case FilterType.DateRange:
            filterState.dateRangeFilter.selectedValue = {
                option: null,
                dateRange: null,
            };
            break;
        default:
            assertNever(type);
    }

    updateItemsViewCache();
}

mutator(clearDateFilterAction, () => {
    clearFilter(FilterType.DateRange);
});

mutator(clearExtensionFilterAction, actionMessage => {
    clearFilter(FilterType.ExtensionGroup, actionMessage.value);
});
